import type { SearchLocation, WaykeLocation } from '../@types/WaykeLocation';

interface LocalStoragePosition {
  position?: WaykeLocation;
  list?: SearchLocation[];
  date?: Date;
}

const localStorageKey = 'wayke-locations';
export const getPosition = (): WaykeLocation | null => {
  try {
    const s = localStorage.getItem(localStorageKey);
    if (!s) return null;
    const locations = JSON.parse(s) as LocalStoragePosition;
    if (
      !locations.date ||
      new Date(locations.date).valueOf() + 24 * 60 * 60 * 1000 < new Date().valueOf()
    ) {
      localStorage.removeItem(localStorageKey);
      return null;
    }
    return {
      ...locations.position,
      lat: Number.parseFloat(locations.position?.lat?.toString() || '0'),
      lng: Number.parseFloat(locations.position?.lng.toString() || '0'),
    } as WaykeLocation;
  } catch (_e) {
    return null;
  }
};

export const setPosition = (position: WaykeLocation | null): WaykeLocation | null => {
  try {
    const locations = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    locations.position = position;
    locations.date = new Date();

    localStorage.setItem(localStorageKey, JSON.stringify(locations));

    return locations.position;
  } catch (_e) {
    return position;
  }
};

const deg2rad = (deg: number) => deg * (Math.PI / 180);

export const getDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
